// extracted by mini-css-extract-plugin
module.exports = {"cornerSprite":"style__cornerSprite__4c3BF","sideSprite":"style__sideSprite__hJTwG","middleSprite":"style__middleSprite__nv+6V"};